import { useState, useEffect, useReducer } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ServerIcon from "remixicon-react/ServerLineIcon";
import CheckDoubleLineIcon from "remixicon-react/CheckDoubleLineIcon";
import { useNavigate } from "react-router-dom";
import { ApiClientType, ApiClient } from "../../../clients/api-client.js";
import WorkroomCard from "../components/workroomCard/ui/workroomCard.js";
import SecondaryButton from "../../../common/crunches/secondaryButton/secondaryButton";
import EmptyTableMsgs from "../../../common/components/emptyTableMsgs/emptyTableMsgs";
import styles from "../styles/workroom.module.css";
import Loader from "../../../common/loaders/clipLoader";
import { DataFetchReducers } from "../../../common/states/dataFetch/dataFetchReducers";
import { dataFetchActionType } from "../../../common/states/dataFetch/dataFetchActionType";
import { getUserDetailsAPI } from "../../../common/apis/commonApis";
import { GetUserId } from "../../../utils/getUserId";

export default function Workroom() {
    const navigate = useNavigate();
    const [workroomData, setWorkroomData] = useState([]);
    const [userGreetingName, setUserGreetingName] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [approvalCount, setApprovalCount] = useState(0);
    const userId = GetUserId();

    const [, dispatchUserDetails] = useReducer(DataFetchReducers, {
        data: null,
        loading: false,
        error: null,
    });

    const getUserDetails = async (id) => {
        try {
            const response = await getUserDetailsAPI(id);
            dispatchUserDetails({
                type: dataFetchActionType.data,
                data: response.data,
            });
            setUserGreetingName(`Hi, ${response?.data?.name}`);
        } catch (err) {
            console.error("Failed to fetch user details", err);
        }
    };

    const getWorkrooms = async () => {
        setIsLoading(true);
        try {
            const response = await ApiClient(
                ApiClientType.get,
                process.env.REACT_APP_MASTER_BASE_URL,
                `/workrooms?name=`,
                {}
            );
            if (response) {
                setWorkroomData(response.data);
            }
        } catch (err) {
            console.error("Failed to fetch workrooms", err);
        } finally {
            setIsLoading(false);
        }
    };

    const getApprovalRequestsCount = async () => {
        try {
            const response = await ApiClient(
                ApiClientType.post,
                process.env.REACT_APP_MASTER_BASE_URL,
                `/approval-steps/search`,
                {
                    filter: {
                        association: "and",
                        conditions: [
                            {
                                field: "approver_ids",
                                operation: "in",
                                value: [userId],
                            },
                            {
                                field: "status",
                                operation: "eq",
                                value: "pending",
                            },
                        ],
                    },
                    page: { limit: 1 },
                }
            );
            setApprovalCount(response?.data?.length || 0);
        } catch (err) {
            console.error("Failed to fetch approval requests", err);
        }
    };

    useEffect(() => {
        getWorkrooms();
        getUserDetails(userId);
        getApprovalRequestsCount();
    }, []);

    return (
        <Container fluid={true} style={{ padding: "40px" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <b
                    style={{
                        fontSize: "24px",
                        color: "black",
                        textShadow: "1px 0 black",
                    }}
                >
                    {userGreetingName}
                </b>

                <div style={{ display: "flex", gap: "12px" }}>
                    <SecondaryButton
                        value={{
                            onClick: () => navigate("/approvals"),
                            child: (
                                <div id={styles.masterData}>
                                    <CheckDoubleLineIcon
                                        size={22}
                                        style={{
                                            color: "#7D7676",
                                            marginRight: "8px",
                                        }}
                                    />
                                    Approvals
                                    {approvalCount > 0 && (
                                        <span
                                            style={{
                                                backgroundColor: "red",
                                                color: "white",
                                                borderRadius: "50%",
                                                padding: "2px 8px",
                                                marginLeft: "8px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                minWidth: "20px",
                                                textAlign: "center",
                                                display: "inline-block",
                                            }}
                                        >
                      {approvalCount}
                    </span>
                                    )}
                                </div>
                            ),
                        }}
                    />

                    <SecondaryButton
                        value={{
                            onClick: () => navigate("/masterData/assets"),
                            child: (
                                <div id={styles.masterData}>
                                    <ServerIcon
                                        size={25}
                                        style={{
                                            color: "#7D7676",
                                            marginTop: "-5px",
                                            marginRight: "10px",
                                        }}
                                    />
                                    Master Data
                                </div>
                            ),
                        }}
                    />
                </div>
            </div>

            {isLoading && <Loader />}

            <Row xs={1} md={1} lg={2}>
                {!isLoading && (
                    <>
                        {workroomData?.length === 0 ? (
                            <EmptyTableMsgs isTable={false} emptyMessage="No Workrooms" />
                        ) : (
                            workroomData?.map((item) => (
                                <Col style={{ padding: "0.25rem 0.5rem" }} key={item.id}>
                                    <WorkroomCard value={{ workroom: item }} />
                                </Col>
                            ))
                        )}
                    </>
                )}
            </Row>
        </Container>
    );
}
